import { getApp } from '@/utils/app'
import actions from './actions'
import getters from './getters'
import mutations from './mutations'
import { AppModule } from './types'

const app: AppModule = {
  state: () => ({
    apps: null,
    selectedAppPosts: [],
    selectedApp: getApp(),
    showMenu: false
  }),
  actions,
  mutations,
  getters,
  namespaced: true,
}

export default app
